import { TargetingReadOnlyList } from '@openx/components-package/components/PackageDetails/sections/TargetingReadOnlyList.tsx';
import { useFilteredTargetingItems } from '@openx/components-package/utils/hooks/useFilteredTargetingItems.ts';
import type { PackageFormState } from '@openx/types/package.ts';

type SelectedPackageDetailsProps = {
  packageState: PackageFormState;
};

export const SelectedPackageDetails = ({ packageState }: SelectedPackageDetailsProps) => {
  const targeting = useFilteredTargetingItems(packageState);

  return <TargetingReadOnlyList targeting={targeting} packageState={packageState} validateLegacyViewFormat={true} />;
};
